<template>
<div>
    <div v-for="(fare, index) in fareRangeOperationTaxes" :key="index" class="row d-flex justify-content-center align-items-center  mt-4 mb-5" @change="handleUpdate">
        <div class="col-3">
            <label>Faixa de taxa efetiva (a.m)</label>
            <!-- <el-input :class="getPrimaryColor" placeholder="0,01%" v-model="fare.fareMin" v-money="numberFloat"/> -->
            <Money class="input-money" v-model="fare.fareMin" v-bind="numberFloat"/>
        </div>
        <div class="col-1 text-center pt-4">
            <p>
                até
            </p>
        </div>
        <div class="col-3 align-self-end">
            <label></label>
            <!-- <el-input :class="getPrimaryColor" placeholder="100%" v-model="fare.fareMax" v-money="numberFloat"/> -->
            <Money class="input-money" v-model="fare.fareMax" v-bind="numberFloat"/>
            <!-- Para quando tiver que travar o valor máximo
            <el-input :class="getPrimaryColor" placeholder="100%" v-model="fare.fareMax" :readonly="(index < fareRangeOperationTaxes.length - 1 ? false : true)"/> -->
        </div>
        <div class="col-3">
            <!-- <InputText v-model.lazy="fare.operationTax" label="Taxa de operação (a.m)" placeholder="0,12%" v-money="numberFloat"/> -->
            <label>Taxa de operação (a.m)</label>
            <!-- <el-input :class="getPrimaryColor" placeholder="0,12%" v-model="fare.operationTax" v-money="numberFloat"/> -->
            <Money class="input-money" v-model="fare.operationTax" v-bind="operationTaxFloat"/>
        </div>
        <div class="col-2 pt-4">
            <el-tooltip class="item" content="Excluir linha" placement="bottom">
                <span @click="removeTaxRange(fare)">
                    <Trash />
                </span>
            </el-tooltip>
        </div>
    </div>
    <div class="col-12 mt-3 pl-0">
        <Button size="small" type="outline" @click="addTaxRange" :color="getPrimaryColor">
            Adicionar nova taxa
        </Button>
    </div>
</div>
</template>

<script>
import Trash from '@/components/icons/Trash'
import { VMoney, Money } from 'v-money'

const numberFloat = {
    thousands: '.',
    decimal: ',',
    precision: 2,
    suffix: '%'
}

export default {
    components: {
        Trash,
        Money
    },
    props: {
        taxes: {
            default: []
        },
        errorTaxes: {
            default: false
        }
    },
    data() {
        return {
            fareRangeOperationTaxes: [
                {
                    fareMin: '0',
                    fareMax: '5000',
                    operationTax: '0'
                },
                {
                    fareMin: '5001',
                    fareMax: '10000',
                    operationTax: '10'                   
                }
            ],
            numberFloat,
            operationTaxFloat: {
                ...numberFloat,
                precision: 3,
            }
        }
    },
    directives: {
        money: VMoney
    },
    watch: {
        fareRangeOperationTaxes() {
            if (this.fareRangeOperationTaxes.length <= 1) this.$emit('changeTaxType')
        }
    },
    computed: {
        fareRangeUnmasked() {
            return this.fareRangeOperationTaxes.map(range => (
                {
                    fareMin: (range.fareMin / 100).toFixed(4),
                    fareMax: (range.fareMax / 100).toFixed(4),
                    operationTax: (range.operationTax / 100).toFixed(4),
                }
            ))
        }
    },
    methods: {
        handleUpdate() {
/*             for (let index = 0; index < this.fareRangeOperationTaxes.length; index++) {
                if (index > 0) {
                    this.fareRangeOperationTaxes[index].fareMin = parseFloat(this.fareRangeOperationTaxes[index - 1].fareMax) + 0.01
                }
            } */
            this.$emit('change', this.fareRangeUnmasked)
        },
        addTaxRange() {
            const fareRangesLength = this.fareRangeOperationTaxes.length - 1
            const lastFareMax = parseFloat(this.fareRangeOperationTaxes[fareRangesLength].fareMax)
            const lastOperationTax = parseFloat(this.fareRangeOperationTaxes[fareRangesLength].operationTax)
            this.fareRangeOperationTaxes.push({
                fareMin: ((lastFareMax + 0.01).toFixed(2)).toString(),
                fareMax: '10000',
                operationTax: ((lastOperationTax + 0.01).toFixed(2)).toString()
            })
        },
        removeTaxRange(fareRange) {
            const fareRangeToRemove = this.fareRangeOperationTaxes.find(range => range.fareMin == fareRange.fareMin && range.fareMax == fareRange.fareMax && range.operationTax == fareRange.operationTax)
            this.fareRangeOperationTaxes = this.fareRangeOperationTaxes.filter(range => range !== fareRangeToRemove )
        },
    },
    created() {
        if ( this.taxes.length ) {
            this.fareRangeOperationTaxes = this.taxes.map(tax => ({
                fareMin: tax.fareMin * 100,
                fareMax: tax.fareMax * 100,
                operationTax: tax.operationTax * 100
            }))
        }
    }
}
</script>

<style lang="scss" scoped>

</style>